<template>
  <div class="payment-page">
    <div v-if="canShowPaymentButton" id="payment-request-button"></div>
    <p v-else>
      Le paiement rapide n'est pas pris en charge sur votre navigateur. Veuillez utiliser une autre méthode.
    </p>
  </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js';

export default {
  name: 'PaymentPage',
  data() {
    return {
      stripe: null,
      canShowPaymentButton: false,
    };
  },
  async mounted() {
    // Charger Stripe avec la clé publique fournie
    this.stripe = await loadStripe('pk_test_51QFEqxDkEvP1FXatT9MOnt31lSEwPToFjY36MvM2Z9YNTeGfWtdLBGuKapfhdmWN3qNv8JaITo9vhFjJC5y8Kzwk00ZAu8mzyH');

    if (this.stripe) {
      this.setupPaymentRequest();
    }
  },
  methods: {
    async setupPaymentRequest() {
      // Créer un objet de demande de paiement avec Stripe
      const paymentRequest = this.stripe.paymentRequest({
        country: 'FR',
        currency: 'eur',
        total: {
          label: 'Supporter le film All On Black',
          amount: 500, // 5.00 euros (en centimes)
        },
        requestPayerName: true,
        requestPayerEmail: true,
      });

      // Vérifier si l'utilisateur peut utiliser une méthode de paiement rapide
      const result = await paymentRequest.canMakePayment();
      if (result) {
        this.canShowPaymentButton = true;

        const elements = this.stripe.elements();
        const prButton = elements.create('paymentRequestButton', {
          paymentRequest,
          style: {
            paymentRequestButton: {
              theme: 'dark', // Options: 'dark', 'light', 'light-outline'
              height: '48px',
            },
          },
        });

        prButton.mount('#payment-request-button');

        paymentRequest.on('paymentmethod', async (event) => {
          // Créer une intention de paiement sur le serveur
          const clientSecret = await this.createPaymentIntent();
          if (!clientSecret) {
            event.complete('fail');
            return;
          }

          // Confirmer le paiement avec Stripe
          const { error } = await this.stripe.confirmCardPayment(clientSecret, {
            payment_method: event.paymentMethod.id,
          });

          if (error) {
            event.complete('fail');
            console.error('Erreur lors du paiement : ', error);
          } else {
            event.complete('success');
            alert('Paiement réussi ! Merci de votre soutien.');
          }
        });
      }
    },
    async createPaymentIntent() {
      // Cette fonction doit envoyer une requête à votre backend
      // pour créer une intention de paiement avec le montant requis
      try {
        const response = await fetch('/create-payment-intent', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ amount: 500 }), // Montant en centimes
        });
        const { clientSecret } = await response.json();
        return clientSecret;
      } catch (error) {
        console.error('Erreur lors de la création de l\'intention de paiement :', error);
        return null;
      }
    },
  },
};
</script>

<style scoped>
.payment-page {
  text-align: center;
  padding: 2em;
  background-color: #000; /* Fond noir pour la page de paiement */
  min-height: 100vh; /* Pour couvrir toute la hauteur de la fenêtre */
  color: #fff; /* Couleur du texte en blanc */
}

#payment-request-button {
  margin: 2em auto;
  max-width: 400px;
}
</style>
